module.exports = __webpack_public_path__ + "static/img/HOME2 768x1024.7eed7cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/capacitador/match/HOME2 768x1024.jpg
// module id = +QJf
// module chunks = 47